
const isErrorDispaly = (objValue) => {
    if (objValue?.data && typeof objValue?.data === "string") {
        return objValue?.data;
    } else if (
        objValue?.response?.data &&
        typeof objValue?.response?.data === "object"
    ) {
        if (
            objValue?.response?.data?.error?.message
                .toLowerCase()
                .includes("modelstate")
        ) {
            return objValue?.response?.data?.error?.message;
        } else if (
            objValue?.response?.data?.errors &&
            typeof objValue?.response?.data?.errors === "object"
        ) {
            const messages = Object.values(objValue?.response?.data?.errors) || [];
            let result = "";
            messages.forEach((message, indx) => {
                result += message + (indx !== messages.length - 1 ? ", " : "");
            });
            return result;
        } else if (objValue?.response?.data?.title) {
            return objValue?.response?.data?.title;
        }
    } else if (
        objValue?.originalError &&
        typeof objValue?.originalError?.message === "string"
    ) {
        return objValue?.originalError?.message;
    } else if (typeof objValue?.response?.data === "object") {
        if (
            objValue?.response?.data?.error?.message &&
            typeof objValue?.response?.data?.error?.message === "string"
        ) {
            return objValue?.response?.data?.error?.message;
        }
    } else if (typeof objValue?.data === "object") {
        if (
            objValue?.data?.error?.message &&
            typeof objValue?.data?.error?.message === "string"
        ) {
            return objValue?.data?.error?.message;
        }
    } else if (objValue?.response?.data?.error?.message) {
        return objValue?.response?.data?.error?.message;
    } else if (objValue?.response?.statusText) {
        return objValue?.response?.statusText;
    } else if (typeof objValue == "string") {
        return objValue;
    }else if (objValue?.title) {
        return objValue?.title;
    }
    else {
        return "Something went wrong please try again!";
    }
};
export { isErrorDispaly };